import { createContext, useCallback, useContext, useState } from "react";
import VirtueGuideModal from "@/components/VirtueGuideModal";

/**
 * VirtueGuideContext — global "open the download modal" surface.
 *
 * The Highlighter (and any explicit CTA that wants the same behaviour) calls
 * `openVirtueGuide()`; the provider owns the modal state so only one modal
 * ever exists in the tree, mounted at the app root.
 */

const VirtueGuideContext = createContext({ openVirtueGuide: () => {} });

export function useVirtueGuide() {
  return useContext(VirtueGuideContext);
}

export function VirtueGuideProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openVirtueGuide = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  return (
    <VirtueGuideContext.Provider value={{ openVirtueGuide }}>
      {children}
      {open && <VirtueGuideModal onClose={close} />}
    </VirtueGuideContext.Provider>
  );
}
